import type { Product, ProductSearchPage } from '@/gen/ecom/models'

interface ProductProperty {
  name: string
  value: string
}

export interface ProductProps extends Product {
  properties?: ReadonlyArray<ProductProperty>
  supplier?: string
  externalProductId?: string
  inContract?: boolean
  displayOnly?: boolean
}

export interface ProductSearchPageExt extends ProductSearchPage {
  products?: ProductProps[]
}

export const enum ProductReferencesType {
  similar = 'SIMILAR',
  upselling = 'UPSELLING',
  accessories = 'ACCESSORIES',
}
